import React, { useState } from 'react'
import Slider from 'react-slick'
import useStyles, { FormInputSelect } from './styles'
import Navbar2 from '../../components/Navbar2/Navbar2'
import Section from '../../components/Section/Section'
import Footer from '../../components/Footer/Footer'
import FormInputNoLabel from '../../components/FormInputNoLabel/FormInputNoLabel'
import Paragraph from '../../components/Typography/Paragraph'
import Card from '../../components/Card/Card'
import Loader from 'react-js-loader'

import giftbox from '../../assets/images/giftbox.png'
import wallet from '../../assets/images/wallet.png'
import slot from '../../assets/images/slot.png'
import result from '../../assets/images/result.png'
import event from '../../assets/images/event.png'
import subscribe from '../../assets/images/subscribe.png'

import {
  Container,
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Collapse,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  RadioGroup,
  Radio,
  FormControlLabel,
  TablePagination,
  Stack,
  Checkbox
} from '@mui/material'
import Button from '../../components/Button/Button'
import {
  AddCircle,
  MoreVert,
  Edit,
  Delete,
  RemoveCircle,
  ExpandMore
} from '@mui/icons-material'
import {
  get_shipping_charge,
  add_shipping_charge,
  edit_shipping_charge,
  delete_shipping_charge,
  get_category,
  get_shipping_country,
  edit_shipping_country,
  edit_shipping_state,
  add_shipping_state,
  delete_shipping_state
} from '../../API/API'
import Countdown from 'react-countdown'
import moment from 'moment/moment'

import './styles.css'
import FormInput from '../../components/FormInput/FormInput'
import { useNavigate, useLocation } from 'react-router-dom'
import toast from 'react-simple-toasts'

export default function ShippingCharge() {
  const classes = useStyles()
  const navigate = useNavigate()
  const location = useLocation()

  const [sort, setSort] = React.useState(0)

  const handleChangeSort = event => {
    setSort(event.target.value)
  }

  const [searchKey, setSearchKey] = React.useState('')
  const handleSearch = event => {
    setSearchKey(event.target.value)
  }

  const [loading, setLoading] = useState(false)
  const [totalList, setTotalList] = React.useState(1)
  const [pageNum, setPageNum] = React.useState(0)

  const [listData, setlistData] = React.useState(null)
  const [countryList, setCountryList] = React.useState(null)
  const [categoryList, setClassList] = React.useState(null)

  const [openAdd, setOpenAdd] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [selectedShipping, setSelectedShipping] = React.useState(null);
  const [addData, setAddData] = React.useState({
    postcode: "",
    large: "",
    light: "",
    medium: "",
    small: "",
  });
  const [openEditCountry, setOpenEditCountry] = React.useState(false);
  const [countryData, setCountryData] = React.useState({
    shipping_country_id: "",
    default_shipping: "",
  });
  const [openAddState, setOpenAddState] = React.useState(false);
  const [openEditState, setOpenEditState] = React.useState(false);
  const [openDeleteState, setOpenDeleteState] = React.useState(false);
  const [selectedState, setSelectedState] = React.useState({
    state_id: "",
    shipping_country_id: ""
  });
  const [stateData, setStateData] = React.useState({
    shipping_country_id: "",
    name: "",
  });

  const getData = () => {
    setLoading(true)
    get_shipping_charge({
      //   page: pageNum + 1
      // sort: sort
    }).then(json => {
      setLoading(false)
      setlistData(json.result)
      //   setTotalList(json.total)
    })
    // get_category({}).then(resCategory => {
    //   setClassList(resCategory.data)
    //   setAddData({
    //     ...addData,
    //     category: resCategory.data[0].category
    //   })
    // })
    get_shipping_country({}).then(resCountry => {
      setCountryList(resCountry.result)
    })
  }

  React.useEffect(() => {
    getData()
  }, [pageNum, sort])

  const handleChangePage = (e, ispage) => {
    setPageNum(ispage)
    // getData();
  }

  const handleOpenAdd = e => {
    setOpenAdd(true)
    setAddData({
      postcode: "",
      large: "",
      light: "",
      medium: "",
      small: "",
    });
  }
  const handleCloseAdd = value => {
    setOpenAdd(false)
  }

  const handleChangeAdd = (e) => {
    setAddData({
      ...addData,
      [e.target.name]: e.target.value,
    });
  };
  const handleAddCharge = () => {
    if (addData.postcode.length == 0) {
      toast("Please enter postcode")
      return
    }
    if (addData.small.length == 0) {
      toast("Please enter small price")
      return
    }
    if (addData.light.length == 0) {
      toast("Please enter light price")
      return
    }
    if (addData.medium.length == 0) {
      toast("Please enter medium price")
      return
    }
    if (addData.large.length == 0) {
      toast("Please enter large price")
      return
    }
    setLoading(true);
    add_shipping_charge(addData).then((json) => {
      if (json.status) {
        setLoading(false);
        toast("Shipping Calculation Price Added")
        handleCloseAdd();
        getData();
        setAddData({
          postcode: "",
          large: "",
          light: "",
          medium: "",
          small: "",
        });
      } else {
        setLoading(false);
        toast(json.message)
      }
    });
  };

  const handleOpenEdit = e => {
    setOpenEdit(true)
    setAddData({
      large: e.large,
      light: e.light,
      medium: e.medium,
      small: e.small,
      postcode: e.postcode,
      shipping_charge_id: e.shipping_charge_id,
    });
  }
  const handleCloseEdit = value => {
    setOpenEdit(false)
  }

  const handleEditCharge = () => {
    setLoading(true);
    edit_shipping_charge(addData).then((json) => {
      if (json.status) {
        setLoading(false);
        toast("Shipping Calculation Price Added")
        handleCloseEdit();
        getData();
        setAddData({
          postcode: "",
          large: "",
          light: "",
          medium: "",
          small: "",
        });
      } else {
        setLoading(false);
        toast(json.message)
      }
    });
  };

  const handleOpenDelete = e => {
    setOpenDelete(true)
    setSelectedShipping(e)
  }
  const handleCloseDelete = value => {
    setOpenDelete(false)
  }
  const handleDeleteShipping = () => {
    setLoading(true);
    delete_shipping_charge({ shipping_charge_id: selectedShipping }).then((json) => {
      if (json.status) {
        setLoading(false);
        toast("Shipping Deleted")
        handleCloseDelete();
        getData();
      } else {
        setLoading(false);
        toast(json.message)
      }
    });
  };

  const handleOpenEditCountry = e => {
    setOpenEditCountry(true)
    setCountryData({
      shipping_country_id: e.shipping_country_id,
      default_shipping: e.default_shipping,
    });
  }
  const handleCloseEditCountry = value => {
    setOpenEditCountry(false)
  }

  const handleEditCountry = () => {
    if (countryData.default_shipping.length == 0) {
      toast('Please enter default shipping')
      return
    }
    setLoading(true);
    edit_shipping_country(countryData).then((json) => {
      if (json.status) {
        setLoading(false);
        toast("Shipping Default Changed")
        handleCloseEditCountry();
        getData();
        setCountryData({
          shipping_country_id: "",
          default_shipping: "",
        });
      } else {
        setLoading(false);
        toast(json.message)
      }
    });
  };

  const handleOpenAddState = e => {
    setOpenAddState(true)
    setStateData({
      shipping_country_id: e.shipping_country_id,
      name: "",
    });
  }
  const handleCloseAddState = value => {
    setOpenAddState(false)
    setStateData({
      shipping_country_id: "",
      name: "",
    });
  }

  const handleChangeState = (e) => {
    setStateData({
      ...stateData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddState = () => {
    if (stateData.name.length == 0) {
      toast('Please enter state name')
      return
    }
    setLoading(true);
    add_shipping_state(stateData).then((json) => {
      if (json.status) {
        setLoading(false);
        toast("State Added")
        handleCloseAddState();
        getData();
        setStateData({
          shipping_country_id: "",
          name: "",
        });
      } else {
        setLoading(false);
        toast(json.message)
      }
    });
  };

  const handleOpenEditState = e => {
    setOpenEditState(true)
    setStateData({
      ...stateData,
      shipping_country_id: e.shipping_country_id,
      name: e.name,
      state_id: e.state_id
    });
  }
  const handleCloseEditState = value => {
    setOpenEditState(false)
  }

  const handleEditState = () => {
    if (stateData.name.length == 0) {
      toast('Please enter state name')
      return
    }
    setLoading(true);
    edit_shipping_state(stateData).then((json) => {
      if (json.status) {
        setLoading(false);
        toast("State Changed")
        handleCloseEditState();
        getData();
        setStateData({
          shipping_country_id: "",
          name: "",
        });
      } else {
        setLoading(false);
        toast(json.message)
      }
    });
  };

  const handleOpenDeleteState = e => {
    setOpenDeleteState(true)
    setSelectedState({
      state_id: e.state_id,
      shipping_country_id: e.shipping_country_id
    })
  }
  const handleCloseDeleteState = value => {
    setOpenDeleteState(false)
  }
  const handleDeleteState = () => {
    setLoading(true);
    delete_shipping_state(selectedState).then((json) => {
      if (json.status) {
        setLoading(false);
        toast("State Deleted")
        handleCloseDeleteState();
        getData();
      } else {
        setLoading(false);
        toast(json.message)
      }
    });
  };


  return (
    <React.Fragment>
      {loading ? (
        <div style={{ margin: 'auto' }}>
          <Loader type='bubble-loop' bgColor='#1A5386' size={50} />
        </div>
      ) : (
        <Navbar2
          children={
            <Section pd='2rem'>
              <div>
                <div className={classes.theFlexHeader}>
                  <Paragraph color='#1A5386' bold='600' size='24px'>
                    Shipping
                  </Paragraph>

                  <div
                    className={classes.theFlexBtn}
                    style={{ marginBottom: '0' }}
                  >
                    {/* <a
                      className={classes.theCustomActionBtn_}
                      onClick={() => handleOpenAddState()}
                    >
                      <AddCircle sx={{ color: '#1A5386' }} />
                      <Paragraph color='#1A5386' margin='0 0 0 .4rem'>
                        Add New Shipping Calculation Price
                      </Paragraph>
                    </a> */}
                    {/* <a
                                            className={classes.theCustomActionBtn_}
                                        // onClick={() => handleOpenStockMove()}
                                        >
                                            <ExitToApp sx={{ color: "#707070" }} />
                                            <Paragraph margin="0 0 0 .4rem">Export</Paragraph>
                                        </a> */}
                  </div>
                </div>
                <div
                  style={{
                    borderBottom: '2px solid #707070',
                    padding: '.2rem 0'
                  }}
                />
                <br />

                <div className={classes.theFlexAction}>
                  {/* <div
                    className={classes.theWx}
                    style={{ margin: '0 20px 0 0' }}
                  >
                    <FormInputNoLabel
                      placeholder='Search'
                      border='1px solid #d7d7d7'
                      br='6px'
                      onChange={handleSearch}
                      value={searchKey}
                    />
                  </div> */}
                  {/* <div className={classes.theWx} style={{ margin: "0 20px 0 0" }}>
                            <FormInputNoLabel
                                placeholder="Search"
                                border="1px solid #d7d7d7"
                                br="6px"
                                onChange={(e) => console.log(e.target.value)}
                                value={searchKey}
                                type="date"
                            />
                        </div> */}
                  {/* <div className={classes.theWx}>
                            <div className={classes.theFlex_}>
                                <FormInputSelect>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={sort}
                                        // defaultValue={sort}
                                        onChange={handleChangeSort}
                                    >
                                        <MenuItem value="0" style={{ color: "#000" }}>
                                            All Payment Type
                                        </MenuItem>
                                        <MenuItem value="1" style={{ color: "#000" }}>
                                            Paid
                                        </MenuItem>
                                        <MenuItem value="2" style={{ color: "#000" }}>
                                            On Hold
                                        </MenuItem>
                                        <MenuItem value="3" style={{ color: "#000" }}>
                                            Cancelled
                                        </MenuItem>
                                    </Select>
                                </FormInputSelect>
                            </div>
                        </div> */}
                </div>

                <Grid container spacing={3}>
                  <Grid item xs={12} sm={12} md={12}>
                    <Card className={classes.theCard}>

                      <div className={classes.theFlexHeader}>
                        <Paragraph color='#1A5386' bold='600' size='24px'>
                          Shipping Default Price
                        </Paragraph>

                        {/* <a
                          className={classes.theCustomActionBtn_}
                          onClick={() => handleOpenAdd()}
                        >
                          <AddCircle sx={{ color: '#1A5386' }} />
                          <Paragraph color='#1A5386' margin='0 0 0 .4rem'>
                            Add New State
                          </Paragraph>
                        </a> */}
                      </div>
                      <br />
                      <TableContainer>
                        <Table>
                          <TableHead style={{ backgroundColor: '#1A5386' }}>
                            <TableRow>
                              <TableCell
                                style={{ borderRadius: '10px 0 0 10px' }}
                                className={classes.theHeadTitle}
                              >
                                Country
                              </TableCell>
                              {/* <TableCell
                                className={classes.theHeadTitle}
                              >
                                State
                              </TableCell> */}
                              <TableCell
                                className={classes.theHeadTitle}
                              >
                                Price
                              </TableCell>
                              <TableCell
                                // align="center"
                                style={{ borderRadius: "0 10px 10px 0" }} className={classes.theHeadTitle}>
                                {/* <MoreVert sx={{ color: "#fff" }} /> */}
                                State List
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {countryList != null &&
                              countryList.map((item, index) => {
                                // if (searchKey != '') {
                                //   if (
                                //     item.postcode.indexOf(
                                //       searchKey.toUpperCase()
                                //     ) <= -1
                                //   ) {
                                //     return
                                //   }
                                // }
                                return (
                                  <TableRow>
                                    <a
                                      style={{ display: 'contents' }}
                                    // href={`../saledetail/${item.sales_order_id}`}
                                    >
                                      <TableCell
                                        style={{
                                          width: "20%",
                                          background: index % 2 == 0 ? "#f2f2f2" : "#fff",
                                        }}
                                      >
                                        {item.country != '' && item.country != null
                                          ? item.country
                                          : '-'}
                                        <div
                                          style={{
                                            // margin: "0 auto",
                                            width: "60%",
                                          }}>
                                          <Button
                                            onClick={() => handleOpenAddState(item)}
                                            label="Add State"
                                            color="#fff"
                                            bg="#1A5386"
                                            size="12px"
                                            pd="10px"
                                            br="5px"
                                            style={{ marginTop: "10px" }}
                                          />
                                        </div>
                                      </TableCell>
                                      {/* <TableCell
                                        style={{
                                          textDecoration: 'underline',
                                          background: index % 2 == 0 ? "#f2f2f2" : "#fff",
                                        }}
                                      // onClick={() =>
                                      //   navigate(
                                      //     '/customerdetail/' +
                                      //     item.customer_id
                                      //   )
                                      // }
                                      >
                                        View &#62;
                                      </TableCell> */}
                                      <TableCell
                                        style={{
                                          width: "20%",
                                          background: index % 2 == 0 ? "#f2f2f2" : "#fff",
                                        }}
                                      // onClick={() =>
                                      //   navigate(
                                      //     '/customerdetail/' +
                                      //     item.customer_id
                                      //   )
                                      // }
                                      >
                                        {item.default_shipping != '' &&
                                          item.default_shipping != null
                                          ? item.default_shipping
                                          : '-'}
                                        <div
                                          style={{
                                            // margin: "0 auto",
                                            width: "60%",
                                          }}>
                                          <Button
                                            onClick={() => handleOpenEditCountry(item)}
                                            label="Edit Price"
                                            color="#fff"
                                            bg="#1A5386"
                                            size="12px"
                                            pd="10px"
                                            br="5px"
                                            style={{ marginTop: "10px" }}
                                          />
                                        </div>
                                      </TableCell>
                                      <TableCell
                                        // align="center"
                                        style={{
                                          background: index % 2 == 0 ? "#f2f2f2" : "#fff",
                                          width: "60%",
                                        }}
                                      >
                                        <Accordion style={{ backgroundColor: "transparent", boxShadow: "none" }}>
                                          <AccordionSummary
                                            // style={{ borderBottom: "1px solid #000" }}
                                            expandIcon={<ExpandMore />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                          >
                                            <Paragraph>State ({item.state.length}) <span style={{ textDecoration: "underline", }}>view all	&#62;</span></Paragraph>
                                            {/* <Typography>Accordion 1</Typography> */}
                                          </AccordionSummary>
                                          <AccordionDetails>
                                            {item.state.length > 0 ?
                                              <React.Fragment>
                                                {item.state.map((resState) =>
                                                  <div className={classes.theStateFlex}>
                                                    <Paragraph>{resState.name}</Paragraph>
                                                    <div>
                                                      <Button
                                                        onClick={() => handleOpenEditState(resState)}
                                                        label="Edit State"
                                                        color="#fff"
                                                        bg="#1A5386"
                                                        size="12px"
                                                        pd="10px"
                                                        br="5px"
                                                        style={{ marginBottom: "10px" }}
                                                      />
                                                      <Button
                                                        onClick={() => handleOpenDeleteState(resState)}
                                                        label="Delete State"
                                                        color="#1A5386"
                                                        bg="#fff"
                                                        box="1px solid #1A5386"
                                                        size="12px"
                                                        pd="10px"
                                                        br="5px"
                                                      />
                                                    </div>
                                                  </div>
                                                )}
                                              </React.Fragment>
                                              :
                                              <React.Fragment>
                                                -
                                              </React.Fragment>
                                            }
                                          </AccordionDetails>
                                        </Accordion>

                                      </TableCell>
                                    </a>
                                  </TableRow>
                                )
                              })}
                          </TableBody>
                        </Table>
                      </TableContainer>

                      {/* <div
                        style={{
                          borderTop: '1px solid #707070',
                          borderBottom: '1px solid #707070',
                          margin: '1rem 0 0',
                          cursor: 'pointer',
                          display: 'flex',
                          justifyContent: 'flex-end',
                          alignItems: 'flex-end'
                        }}
                      >
                        <TablePagination
                          // variant="outlined"
                          color='primary'
                          page={pageNum}
                          onPageChange={handleChangePage}
                          count={totalList}
                          // defaultPage={pageList}
                          rowsPerPage={10}
                          rowsPerPageOptions={[10]}
                          // count={10}
                        />
                      </div> */}
                    </Card>
                    <br />
                    <br />
                  </Grid>
                </Grid>

                <Grid container spacing={3}>
                  <Grid item xs={12} sm={12} md={12}>
                    <Card className={classes.theCard}>
                      <div className={classes.theFlexHeader}>
                        <Paragraph color='#1A5386' bold='600' size='24px'>
                          Shipping Calculation Price
                        </Paragraph>

                        <a
                          className={classes.theCustomActionBtn_}
                          onClick={() => handleOpenAdd()}
                        >
                          <AddCircle sx={{ color: '#1A5386' }} />
                          <Paragraph color='#1A5386' margin='0 0 0 .4rem'>
                            Add New Shipping Calculation Price
                          </Paragraph>
                        </a>
                      </div>
                      <br />
                      <div
                        className={classes.theWx}
                        style={{ margin: '0 20px 0 0' }}
                      >
                        <FormInputNoLabel
                          placeholder='Search'
                          border='1px solid #d7d7d7'
                          br='6px'
                          onChange={handleSearch}
                          value={searchKey}
                        />
                      </div>
                      <br />
                      <TableContainer>
                        <Table>
                          <TableHead style={{ backgroundColor: '#1A5386' }}>
                            <TableRow>
                              <TableCell
                                style={{ borderRadius: '10px 0 0 10px' }}
                                className={classes.theHeadTitle}
                              >
                                Postcode
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Small
                              </TableCell>
                              <TableCell
                                className={classes.theHeadTitle}
                              >
                                Large
                              </TableCell>
                              <TableCell
                                className={classes.theHeadTitle}
                              >
                                Medium
                              </TableCell>
                              <TableCell
                                className={classes.theHeadTitle}
                              >
                                Light
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ borderRadius: "0 10px 10px 0" }} className={classes.theHeadTitle}>
                                <MoreVert sx={{ color: "#fff" }} />
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {listData != null &&
                              listData.map((item, index) => {
                                if (searchKey != '') {
                                  if (
                                    item.postcode.indexOf(
                                      searchKey.toUpperCase()
                                    ) <= -1
                                  ) {
                                    return
                                  }
                                }
                                return (
                                  <TableRow>
                                    <a
                                      style={{ display: 'contents' }}
                                    // href={`../saledetail/${item.sales_order_id}`}
                                    >
                                      <TableCell
                                        style={{
                                          textDecoration: 'underline',
                                          background: index % 2 == 0 ? "#f2f2f2" : "#fff",
                                        }}
                                      >
                                        {item.postcode != '' && item.postcode != null
                                          ? item.postcode
                                          : '-'}
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          background: index % 2 == 0 ? "#f2f2f2" : "#fff",
                                        }}
                                      // onClick={() =>
                                      //   navigate(
                                      //     '/customerdetail/' +
                                      //     item.customer_id
                                      //   )
                                      // }
                                      >
                                        {item.small != '' &&
                                          item.small != null
                                          ? item.small
                                          : '-'}
                                      </TableCell>
                                      <TableCell style={{
                                        background: index % 2 == 0 ? "#f2f2f2" : "#fff",
                                      }}>
                                        {item.large != '' && item.large != null
                                          ? item.large
                                          : '-'}
                                      </TableCell>
                                      <TableCell style={{
                                        background: index % 2 == 0 ? "#f2f2f2" : "#fff",
                                      }}>
                                        {item.medium != '' && item.medium != null
                                          ? item.medium
                                          : '-'}
                                      </TableCell>
                                      <TableCell style={{
                                        background: index % 2 == 0 ? "#f2f2f2" : "#fff",
                                      }}>
                                        {item.light != '' && item.light != null
                                          ? item.light
                                          : '-'}
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          background: index % 2 == 0 ? "#f2f2f2" : "#fff",
                                          width: "10%"
                                        }}
                                      >
                                        <Button
                                          onClick={() => handleOpenEdit(item)}
                                          label="Edit"
                                          color="#fff"
                                          bg="#1A5386"
                                          size="12px"
                                          pd="10px"
                                          br="5px"
                                          style={{ marginBottom: "10px" }}
                                        />
                                        <Button
                                          onClick={() => handleOpenDelete(item.shipping_charge_id)}
                                          label="Delete"
                                          color="#1A5386"
                                          bg="#fff"
                                          box="1px solid #1A5386"
                                          size="12px"
                                          pd="10px"
                                          br="5px"
                                        />
                                      </TableCell>
                                    </a>
                                  </TableRow>
                                )
                              })}
                          </TableBody>
                        </Table>
                      </TableContainer>

                      {/* <div
        style={{
          borderTop: '1px solid #707070',
          borderBottom: '1px solid #707070',
          margin: '1rem 0 0',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'flex-end'
        }}
      >
        <TablePagination
          // variant="outlined"
          color='primary'
          page={pageNum}
          onPageChange={handleChangePage}
          count={totalList}
          // defaultPage={pageList}
          rowsPerPage={10}
          rowsPerPageOptions={[10]}
          // count={10}
        />
      </div> */}
                    </Card>
                    <br />
                    <br />
                  </Grid>
                </Grid>
                <br />
                <br />
              </div>

              <Dialog
                onClose={handleCloseAdd}
                open={openAdd}
                fullWidth='true'
                maxWidth='sm'
              >
                <DialogTitle>
                  <Paragraph color="#1A5386" bold="600" size="24px">
                    Add Shipping Calculation Price
                  </Paragraph>
                </DialogTitle>
                <DialogContent>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={4} md={6}>
                      <FormInput
                        label="Postcode*"
                        value={addData.postcode}
                        textLabelColor="#000"
                        placeholder="Postcode"
                        name="postcode"
                        border="1px solid #c5c5c5"
                        onChange={handleChangeAdd}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={6}>
                      <FormInput
                        label="Small*"
                        value={addData.small}
                        textLabelColor="#000"
                        placeholder="Small"
                        name="small"
                        type="number"
                        border="1px solid #c5c5c5"
                        onChange={handleChangeAdd}
                      >
                      </FormInput>
                    </Grid>
                    <Grid item xs={12} sm={4} md={6}>
                      <FormInput
                        label="Light*"
                        value={addData.light}
                        textLabelColor="#000"
                        placeholder="Light"
                        name="light"
                        type="number"
                        border="1px solid #c5c5c5"
                        onChange={handleChangeAdd}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={6}>
                      <FormInput
                        label="Medium*"
                        value={addData.medium}
                        textLabelColor="#000"
                        placeholder="Medium"
                        name="medium"
                        border="1px solid #c5c5c5"
                        onChange={handleChangeAdd}
                      >
                      </FormInput>
                    </Grid>
                    <Grid item xs={12} sm={4} md={6}>
                      <FormInput
                        label="Large*"
                        value={addData.large}
                        textLabelColor="#000"
                        placeholder="Large"
                        name="large"
                        type="number"
                        border="1px solid #c5c5c5"
                        onChange={handleChangeAdd}
                      />
                    </Grid>
                  </Grid>
                  <Button
                    onClick={() => handleAddCharge()}
                    label="Add"
                    color="#fff"
                    bg="#1A5386"
                    size="18px"
                    pd="10px"
                    br="5px"
                    style={{ marginBottom: "10px" }}
                  />
                </DialogContent>
              </Dialog>

              <Dialog
                onClose={handleCloseEdit}
                open={openEdit}
                fullWidth='true'
                maxWidth='sm'
              >
                <DialogTitle>
                  <Paragraph color="#1A5386" bold="600" size="24px">
                    Edit Shipping Calculation Price
                  </Paragraph>
                </DialogTitle>
                <DialogContent>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={4} md={6}>
                      <FormInput
                        label="Postcode*"
                        value={addData.postcode}
                        textLabelColor="#000"
                        placeholder="Postcode"
                        name="postcode"
                        border="1px solid #c5c5c5"
                        onChange={handleChangeAdd}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={6}>
                      <FormInput
                        label="Small*"
                        value={addData.small}
                        textLabelColor="#000"
                        placeholder="Small"
                        name="small"
                        type="number"
                        border="1px solid #c5c5c5"
                        onChange={handleChangeAdd}
                      >
                      </FormInput>
                    </Grid>
                    <Grid item xs={12} sm={4} md={6}>
                      <FormInput
                        label="Light*"
                        value={addData.light}
                        textLabelColor="#000"
                        placeholder="Light"
                        name="light"
                        type="number"
                        border="1px solid #c5c5c5"
                        onChange={handleChangeAdd}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={6}>
                      <FormInput
                        label="Medium*"
                        value={addData.medium}
                        textLabelColor="#000"
                        placeholder="Medium"
                        name="medium"
                        border="1px solid #c5c5c5"
                        onChange={handleChangeAdd}
                      >
                      </FormInput>
                    </Grid>
                    <Grid item xs={12} sm={4} md={6}>
                      <FormInput
                        label="Large*"
                        value={addData.large}
                        textLabelColor="#000"
                        placeholder="Large"
                        name="large"
                        type="number"
                        border="1px solid #c5c5c5"
                        onChange={handleChangeAdd}
                      />
                    </Grid>
                  </Grid>
                  <Button
                    onClick={() => handleEditCharge()}
                    label="Save"
                    color="#fff"
                    bg="#1A5386"
                    size="18px"
                    pd="10px"
                    br="5px"
                    style={{ marginBottom: "10px" }}
                  />
                </DialogContent>
              </Dialog>

              <Dialog
                onClose={handleCloseDelete}
                open={openDelete}
                fullWidth='true'
                maxWidth='sm'
              >
                <DialogTitle>
                  <Paragraph color="#1A5386" bold="600" size="24px">
                    Delete Shipping Calculation Price
                  </Paragraph>
                </DialogTitle>
                <DialogContent>
                  <Paragraph color="#000" bold="600" size="16px" margin="0 0 1rem">
                    Are you sure to delete this Shipping Calculation Price?
                  </Paragraph>
                  <Button
                    onClick={() => handleDeleteShipping()}
                    label="Delete"
                    color="#fff"
                    bg="#1A5386"
                    size="18px"
                    pd="10px"
                    br="5px"
                    style={{ marginBottom: "10px" }}
                  />
                </DialogContent>
              </Dialog>

              <Dialog
                onClose={handleCloseEditCountry}
                open={openEditCountry}
                fullWidth='true'
                maxWidth='sm'
              >
                <DialogTitle>
                  <Paragraph color="#1A5386" bold="600" size="24px">
                    Edit Default Shipping
                  </Paragraph>
                </DialogTitle>
                <DialogContent>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormInput
                        label="Default Shipping*"
                        value={countryData.default_shipping}
                        textLabelColor="#000"
                        placeholder="Default Shipping"
                        name="default_shipping"
                        border="1px solid #c5c5c5"
                        type='number'
                        inputProps={{ min: 0 }}
                        onChange={(e) => setCountryData({
                          ...countryData,
                          default_shipping: e.target.value
                        })}
                      />
                    </Grid>
                  </Grid>
                  <Button
                    onClick={() => handleEditCountry()}
                    label="Save"
                    color="#fff"
                    bg="#1A5386"
                    size="18px"
                    pd="10px"
                    br="5px"
                    style={{ marginBottom: "10px" }}
                  />
                </DialogContent>
              </Dialog>

              <Dialog
                onClose={handleCloseAddState}
                open={openAddState}
                fullWidth='true'
                maxWidth='sm'
              >
                <DialogTitle>
                  <Paragraph color="#1A5386" bold="600" size="24px">
                    Add State
                  </Paragraph>
                </DialogTitle>
                <DialogContent>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormInput
                        label="Name*"
                        value={stateData.name}
                        textLabelColor="#000"
                        placeholder="Name"
                        name="name"
                        border="1px solid #c5c5c5"
                        onChange={handleChangeState}
                      />
                    </Grid>
                  </Grid>
                  <Button
                    onClick={() => handleAddState()}
                    label="Add"
                    color="#fff"
                    bg="#1A5386"
                    size="18px"
                    pd="10px"
                    br="5px"
                    style={{ marginBottom: "10px" }}
                  />
                </DialogContent>
              </Dialog>

              <Dialog
                onClose={handleCloseEditState}
                open={openEditState}
                fullWidth='true'
                maxWidth='sm'
              >
                <DialogTitle>
                  <Paragraph color="#1A5386" bold="600" size="24px">
                    Edit State
                  </Paragraph>
                </DialogTitle>
                <DialogContent>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormInput
                        label="Name*"
                        value={stateData.name}
                        textLabelColor="#000"
                        placeholder="Name"
                        name="name"
                        border="1px solid #c5c5c5"
                        onChange={handleChangeState}
                      />
                    </Grid>
                  </Grid>
                  <Button
                    onClick={() => handleEditState()}
                    label="Save"
                    color="#fff"
                    bg="#1A5386"
                    size="18px"
                    pd="10px"
                    br="5px"
                    style={{ marginBottom: "10px" }}
                  />
                </DialogContent>
              </Dialog>

              <Dialog
                onClose={handleCloseDeleteState}
                open={openDeleteState}
                fullWidth='true'
                maxWidth='sm'
              >
                <DialogTitle>
                  <Paragraph color="#1A5386" bold="600" size="24px">
                    Delete State
                  </Paragraph>
                </DialogTitle>
                <DialogContent>
                  <Paragraph color="#000" bold="600" size="16px" margin="0 0 1rem">
                    Are you sure to delete this state?
                  </Paragraph>
                  <Button
                    onClick={() => handleDeleteState()}
                    label="Delete"
                    color="#fff"
                    bg="#1A5386"
                    size="18px"
                    pd="10px"
                    br="5px"
                    style={{ marginBottom: "10px" }}
                  />
                </DialogContent>
              </Dialog>
            </Section>
          }
        />
      )}
    </React.Fragment >
  )
}
